/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonRelayerChannelTrxInfo = {
    TRXHA: string;
    STAT: BabylonRelayerChannelTrxInfo.STAT;
    MSGTP: string;
    BNO: string;
    AMT: string;
    AMTVAL: string;
    DENOM: string;
    SB: string;
    TRXF: string;
    TRXFVAL: string;
    AG: string;
    UT: number;
};

export namespace BabylonRelayerChannelTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

